import { render, staticRenderFns } from "./MenuItemAggregatorsSettings.vue?vue&type=template&id=6677e994&scoped=true&"
import script from "./MenuItemAggregatorsSettings.vue?vue&type=script&lang=js&"
export * from "./MenuItemAggregatorsSettings.vue?vue&type=script&lang=js&"
import style0 from "./MenuItemAggregatorsSettings.vue?vue&type=style&index=0&id=6677e994&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6677e994",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VSwitch,VTextField})
